<template>
  <div class="has-text-centered">
    <section class="section">
      <div class="container">
        <div class="columns is-vcentered has-text-centered">
          <div class="column has-text-centered">
            <img src="https://media.stadssalg.no/404.png" width="400" />
            <p class="subtitle mt-3">
              {{ $t("error.itemNotFound") }}
            </p>
            <div class="buttons is-centered">
              <router-link :to="{ name: 'Home' }"
                ><button class="button is-primary">
                  {{ $t("error.home") }}
                </button></router-link
              >
              <router-link :to="{ name: 'Items' }">
                <button class="button is-link">
                  {{ $t("error.otherItems") }}
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Error",

  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
